import { Add } from '@mui/icons-material'
import { Box, Button, Typography } from '@mui/material'
import axios from 'axios'
import { isAdmin } from 'chezy-inventory-backend/bin/auth/AuthenticationContext'
import { Bin } from 'chezy-inventory-backend/bin/database/types/Bin'
import { useContext, useEffect, useState } from 'react'

import { AuthContext } from '../../utils/authContext'
import { BinWithChildren, mkBinHeirarchy } from '../../utils/createBinTree'
import { getBaseURL } from '../../utils/getBaseURL'

import { BinOutline } from './binOutline'
import { BinFormData, CreateBinForm } from './createBinForm'

const NoBinViewer = (props: { allBins: Bin[]; onReload?: () => void; onSelectBin: (id: string) => void }) => {
  const [binAddFormOpen, setBinAddFormOpen] = useState(false)
  const [tree, setTree] = useState<BinWithChildren[]>([])

  const authContext = useContext(AuthContext)

  useEffect(() => {
    setTree(mkBinHeirarchy(props.allBins, undefined))
  }, [props.allBins])

  const saveBin = (data: BinFormData) => {
    axios
      .post(`${getBaseURL()}/bin/${data.id}`, {
        ...data,
        parent_id: null,
      })
      .then(() => {
        setBinAddFormOpen(false)
        props.onReload?.()
      })
  }

  return (
    <Box>
      <Typography variant="h4">All Totes:</Typography>
      {authContext?.tokenData && isAdmin(authContext.tokenData) && (
        <Button onClick={() => setBinAddFormOpen(true)}>
          <Add /> Create a new Tote
        </Button>
      )}

      <BinOutline bins={tree} onClick={props.onSelectBin} />
      <CreateBinForm
        isOpen={binAddFormOpen}
        onDismiss={() => setBinAddFormOpen(false)}
        onSave={saveBin}
        parentBin={undefined}
      />
    </Box>
  )
}

export { NoBinViewer }
